module.exports = __webpack_public_path__ + "static/media/19ESCAP22.d53709fe.jpg";